// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let _;
let moment;
let RivalIQ;
let $;
if (typeof window === 'undefined') {

    _ = require('lodash');
    $ = require('jquery');
    moment = require('../../../lib/riq-moment.js');
    RivalIQ = {
        enums: require('../../enums/metrics.js'),
        data: {
            CompareData: require('../data/compareData.js'),
            LinkedInJobFunctionMap: require('../data/linkedInJobFunctions.js')
        },
        utils: {
            companyDisplay: require('./companyDisplay.js')
        },
        metric: {
            property: require('../metric/property.js')
        }
    };

    RivalIQ.utils.incompleteData = module.exports;

} else {
    _ = window._;
    $ = window.$;
    moment = window.moment;
    RivalIQ = window.RivalIQ;
    RivalIQ.module('utils', function (utils) {
        'use strict';

        utils.incompleteData = {};
    });
}

(function (incompleteData) {
    'use strict';

    const sources = RivalIQ.enums.sources;
    // see https://github.com/RivalIQ/rivaliq-server/issues/30442#issuecomment-943610112
    const historyPullInDaysBySource = {
        [sources.LINKEDIN]: {
            duration: 2,
            durationType: 'years'
        },
        [sources.FACEBOOK_INSIGHTS]: {
            duration: 2,
            durationType: 'years'
        },
        [sources.INSTAGRAM_INSIGHTS]: {
            duration: 3,
            durationType: 'years'
        },
        [sources.TWITTER_INSIGHTS]: {
            duration: 90,
            durationType: 'days'
        }
    };

    const getAllChannelPresences = function (companyAttrs) {
        const records = {};
        _.each(RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.CROSS_CHANNEL].subSources, function (source) {
            const record = RivalIQ.utils.companyDisplay.getSourcePrimaryRecord(source, companyAttrs);
            if (record) {
                records[source] = record;
            }
        });

        return records;
    };

    const getMissingSubmetrics = function (source, companyAttrs, subMetrics) {
        const records = getAllChannelPresences(companyAttrs);
        const missingSubMetrics = [];
        let missingAllSubmetrics = true;
        if (source === RivalIQ.enums.sources.CROSS_CHANNEL) {
            _.each(subMetrics, function (metric) {
                const sourceDetail = _.find(RivalIQ.enums.sourceDetails, {
                    channel: metric.metric
                });
                const source = _.get(sourceDetail, 'source');
                if (records[source]) {
                    missingAllSubmetrics = false;
                } else if (sourceDetail) {
                    // track the channels without a presence
                    missingSubMetrics.push(sourceDetail.name);
                }
            });
        }

        return {
            missingSubMetrics: missingSubMetrics,
            missingAllSubmetrics: missingAllSubmetrics
        };
    };

    const findLatestCrossChannelDate = function (dateType, companyAttrs) {
        const records = getAllChannelPresences(companyAttrs);

        // set initial date to before RivalIQ was born
        const max = {
            date: moment.utc('2010-01-01'),
            count: 0
        };

        _.each(records, function (record, source) {
            const addedDate = _.get(record, ['dates', dateType]);
            if (addedDate && moment.utc(addedDate).isAfter(max.date)) {
                max.date = moment.utc(record.dates[dateType]);
                max.count = 1;
                max.channel = RivalIQ.enums.sourceDetails[source].name;
            }
        });

        if (max.count) {
            max.count = 0;
            _.each(records, function (record, source) {
                const addedDate = _.get(record, ['dates', dateType]);
                if (addedDate && moment.utc(addedDate).isSameOrAfter(max.date)) {
                    max.count++;
                    max.channel = RivalIQ.enums.sourceDetails[source].name;
                }
            });
        }

        return max;
    };

    const getNoHistoricalDataDescription = function () {
        return `We begin tracking audience data only after a presence has been added to Rival IQ, and aren’t able to obtain historical audience numbers. Read more about data history and data limits in our <a target='_blank' href='https://help.rivaliq.com/frequently-asked-questions/about-data/what-does-not-enough-history-mean'>help center</a>.`;
    };

    const getNoHistoricalDataTitleForSingleChannel = function (channelName, date, companyName) {
        date = moment.utc(date).format('MMMM D, YYYY');
        return `${channelName} audience data for ${companyName} is available only starting on ${date}.`;
    };

    const getNoHistoricalDataTitleForSingleChannelChange = function (channelName, date, companyName) {
        date = moment.utc(date).format('MMMM D, YYYY');
        return `Since ${channelName} audience data for ${companyName} is available only starting on ${date}, there is not enough data to calculate net change.`;
    };

    const getNoHistoricalDataTitleForCrossChannelChange = function (latestDate, companyName) {
        const date = moment.utc(latestDate.date).format('MMMM D, YYYY');

        let title;
        if (latestDate.count === 1) {
            title = `Since ${latestDate.channel} audience data for ${companyName} is available only starting on ${date}`;
        } else {
            title = `Since audience data for multiple channels for ${companyName} is available only starting on ${date}`;
        }
        title += ', there is not enough data to calculate net change.';

        return title;
    };

    const getNoHistoricalDataTitleForCrossChannel = function (earliestDate) {
        const date = moment.utc(earliestDate.date).format('MMMM D, YYYY');
        const title = `This company was added to Rival IQ after the selected time period. We do not have audience history before ${date}.`;
        return title;
    };

    const getLimitedHistoricalDataDescription = function (source, objectType, earliestDate) {
        if (objectType === 'stories' || objectType === 'storyDay') {
            const date = moment.utc(earliestDate).format('MMMM D, YYYY');
            return `We begin tracking Stories data once the handle is connected to Rival IQ. We are not able to retrieve historical data for stories. Story data isn't available for any handles prior to ${date}.`;
        } else if (RivalIQ.enums.sourceDetails[source].privateData) {
            const channelName = RivalIQ.enums.sourceDetails[source].name;
            return `When we begin tracking ${channelName} data for a presence, we retrieve up to ${historyPullInDaysBySource[source].duration} ${historyPullInDaysBySource[source].durationType} of historical post data, depending on post volume and platform limitations. Read more about data history and data limits in our <a target='_blank' href='https://help.rivaliq.com/frequently-asked-questions/about-data/what-does-not-enough-history-mean'>help center</a>.`;
        }
        return `When we begin tracking post data for a presence, we retrieve up to 2 years of historical post data, depending on post volume and platform limitations. Read more about data history and data limits in our <a target='_blank' href='https://help.rivaliq.com/frequently-asked-questions/about-data/what-does-not-enough-history-mean'>help center</a>.`;
    };

    const getNoAggregateDataTitleForSingleChannel = function (channelName, metricName, date, companyName) {
        date = moment.utc(date).format('MMMM D, YYYY');
        return `${[channelName, metricName, `data for ${companyName} is available only starting on`, date].join(' ')}.`;
    };

    const getNoAggregateDataTitleForCrossChannel = function (metricName, latestDate, companyName) {
        const date = moment.utc(latestDate.date).format('MMMM D, YYYY');
        let title = `Cross-Channel ${metricName} data for ${companyName} is only available starting on ${date} because `;
        if (latestDate.count === 1) {
            title += `${latestDate.channel} post data `;
        } else {
            title += 'post data for multiple channels ';
        }
        title += `isn't available before that date.`;
        return title;
    };

    const getDataNotAvailableMessage = function (date) {
        date = moment.utc(date).format('MMMM D, YYYY');
        return ['Data not available before', date].join(' ');
    };

    const getLatestDate = incompleteData.getLatestDate = function (source, companyAttributes, dataType) {
        if (source === RivalIQ.enums.sources.CROSS_CHANNEL) {
            return findLatestCrossChannelDate(dataType, companyAttributes);
        }

        const record = RivalIQ.utils.companyDisplay.getSourcePrimaryRecord(source, companyAttributes);
        return {
            channel: RivalIQ.enums.sourceDetails[source].name,
            date: _.get(record, ['dates', dataType])
        };
    };

    function isDeltaTimeAnalysisMode(timeAnalysisMode) {
        return _.includes([RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE, RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE], timeAnalysisMode);
    }

    incompleteData.getIncompleteDataType = function (company, source, dataUpdateInFlight, timePeriod, earliestDataDateByCompanyId, noHistoricData, subMetrics, timeAnalysisMode) {
        const loadingData = company.stillFinding();

        const earliestDataDate = _.get(earliestDataDateByCompanyId, company.id);
        const errors = RivalIQ.enums.incompleteDataType;
        const missingSubMetrics = getMissingSubmetrics(source, company.attributes, subMetrics);
        const trackingStartsAfterPeriodStart = moment.utc(earliestDataDate).isAfter(moment.utc(timePeriod.mainPeriodStart));

        // NOTE: data updates don't affect metrics that have no historic data
        if (!noHistoricData && loadingData) {
            return errors.DATA_IN_FLIGHT;
        } else if (source === RivalIQ.enums.sources.CROSS_CHANNEL && subMetrics.length > 0 && missingSubMetrics.missingAllSubmetrics && timeAnalysisMode === RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD) {
            return errors.NO_ACTIVE_RECORDS;
        } else if (!earliestDataDate && !(_.isNull(earliestDataDate) && source === RivalIQ.enums.sources.LINKEDIN)) {
            // NOTE: earliestDataDate can be null if a presence has no posts on linkedin
            // edge case: protected data or no private access
            return RivalIQ.enums.sourceDetails[source].privateData ? errors.NO_PRIVATE_ACCESS : errors.PROTECTED_DATA;
        } else if (noHistoricData && isDeltaTimeAnalysisMode(timeAnalysisMode)) {
            return (source === RivalIQ.enums.sources.CROSS_CHANNEL ? errors.CROSS_CHANNEL_HISTORICAL : errors.CHANNEL_HISTORICAL);
        } else if (timePeriod.mainPeriodStart <= earliestDataDate && earliestDataDate <= timePeriod.mainPeriodEnd) {
            // we start tracking in the middle on the period, check to make sure we have enough valid data
            const start = timePeriod.mainPeriodStart;
            const end = moment.utc(timePeriod.mainPeriodEnd);
            const validDataDays = moment.duration(end.diff(earliestDataDate)).asDays();
            const totalDays = moment.duration(end.diff(start)).asDays();
            // finish combing the math later.....
            const allowedMissingDataPointsFloor = 3;
            const allowedMissingDataPointsFactor = 0.1;

            const allowedMissingDataPoints = (validDataDays >= allowedMissingDataPointsFloor ? Math.ceil(validDataDays * allowedMissingDataPointsFactor) : 0);
            const minMissingDataDays = (totalDays - allowedMissingDataPoints);
            return (validDataDays < minMissingDataDays ? errors.NOT_ENOUGH_DATA_IN_PERIOD : errors.NOT_ENOUGH_HISTORY);
        } else if (source === RivalIQ.enums.sources.CROSS_CHANNEL && trackingStartsAfterPeriodStart) {
            return (noHistoricData ? errors.CROSS_CHANNEL_HISTORICAL : errors.CROSS_CHANNEL_AGGREGATE);
        } else if (timePeriod.mainPeriodStart < earliestDataDate && trackingStartsAfterPeriodStart) {
            return (noHistoricData ? errors.CHANNEL_HISTORICAL : errors.CHANNEL_AGGREGATE);
        }

        return errors.NOT_ENOUGH_HISTORY;
    };

    incompleteData.getIncompleteDataText = function (incompleteDataType, companyAttributes, timePeriod, companyName, metricName, source, earliestDataDateByCompanyId, metricObjectType, noHistoricData, subMetrics, timeAnalysisMode, excludedChannels) {
        const errors = RivalIQ.enums.incompleteDataType;
        const channelName = RivalIQ.enums.sourceDetails[source].name;
        const earliestDataDate = earliestDataDateByCompanyId[companyAttributes.id];
        let latestDate;
        timeAnalysisMode = timeAnalysisMode || RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD;

        switch (incompleteDataType) {
            case errors.CROSS_CHANNEL_HISTORICAL:
                latestDate = findLatestCrossChannelDate('earliestPresenceData', companyAttributes, excludedChannels);
                if (isDeltaTimeAnalysisMode(timeAnalysisMode)) {
                    return {
                        message: 'Net change not available',
                        title: getNoHistoricalDataTitleForCrossChannelChange(latestDate, companyName),
                        description: getNoHistoricalDataDescription()
                    };
                }

                return {
                    message: ['Data not available before', moment.utc(latestDate.date).format('MMMM D, YYYY')].join(' '),
                    title: getNoHistoricalDataTitleForCrossChannel(latestDate),
                    description: getNoHistoricalDataDescription()
                };

            case errors.CROSS_CHANNEL_AGGREGATE:
                latestDate = getLatestDate(source, companyAttributes, 'earliestPostData');
                return {
                    message: ['Data not available before', moment.utc(latestDate.date).format('MMMM D, YYYY')].join(' '),
                    title: getNoAggregateDataTitleForCrossChannel(metricName, latestDate, companyName),
                    description: getLimitedHistoricalDataDescription(source, metricObjectType, latestDate.date)
                };

            case errors.CHANNEL_AGGREGATE:
                return {
                    message: getDataNotAvailableMessage(earliestDataDate),
                    title: getNoAggregateDataTitleForSingleChannel(channelName, metricName, earliestDataDate, companyName),
                    description: getLimitedHistoricalDataDescription(source, metricObjectType, earliestDataDate)
                };

            case errors.CHANNEL_HISTORICAL:
                if (isDeltaTimeAnalysisMode(timeAnalysisMode)) {
                    return {
                        message: 'Net change not available',
                        title: getNoHistoricalDataTitleForSingleChannelChange(channelName, earliestDataDate, companyName),
                        description: getNoHistoricalDataDescription()
                    };
                }

                return {
                    message: getDataNotAvailableMessage(earliestDataDate),
                    title: getNoHistoricalDataTitleForSingleChannel(channelName, earliestDataDate, companyName),
                    description: getNoHistoricalDataDescription()
                };

            case errors.NOT_ENOUGH_DATA_IN_PERIOD: {
                const formattedDate = moment.utc(earliestDataDate).format('MMMM D, YYYY');

                return {
                    message: 'Not enough history',
                    title: `We started tracking ${channelName} ${metricName} for ${companyName} on ${formattedDate}, so update your time period after that date to view these metrics.`,
                    description: getLimitedHistoricalDataDescription(source, metricObjectType, earliestDataDate)
                };
            }
            case errors.DATA_IN_FLIGHT:
                return {
                    message: 'Loading recent data...',
                    title: 'Loading recent data',
                    description: `${[`It looks like we're still loading data for`, `${companyName}.`, 'It should be ready in a few minutes'].join(' ')}.`
                };

            case errors.NO_ACTIVE_RECORDS: {
                const missingSubMetrics = getMissingSubmetrics(source, companyAttributes, subMetrics);
                const missingSubMetricsText = missingSubMetrics.missingSubMetrics.join(' or ');
                const word = missingSubMetrics.missingSubMetrics.length > 1 ? 'it' : 'them';

                if (source === RivalIQ.enums.sources.LINKEDIN) {
                    return {
                        message: 'No presences found',
                        title: `If you know any ${missingSubMetricsText} presences for ${companyName}, please add ${word} in <a href='/companies'>Companies</a>.`,
                        unboldTitle: true
                    };
                }

                return {
                    message: 'No presences found',
                    title: `If you know any ${missingSubMetricsText} presences for ${companyName}, please add ${word} in <a href='/companies'>Companies</a>.`,
                    unboldTitle: true
                };
            }
            case errors.PROTECTED_DATA:
                return {
                    message: 'Data not available',
                    title: [
                        companyName,
                        'does not have',
                        channelName,
                        metricName,
                        'data. If you have any questions, please contact our <a onClick="handleIntercomChat()">support team</a>.'
                    ].join(' '),
                    unboldTitle: true
                };

            case errors.NO_PRIVATE_ACCESS:
                return {
                    message: 'Data not available',
                    title: `${companyName} is not connected to ${channelName}. Connect your account <a href="/account/services">here</a>.`,
                    unboldTitle: true
                };

            case errors.NOT_ENOUGH_HISTORY:
                return {
                    message: 'Not enough history',
                    title: 'Not enough history',
                    unboldTitle: true
                };
            default:
                throw new Error(`unknown incomplete data error type ${incompleteDataType}`);
        }
    };

    function isYouTubeSubCountHidden(companyAttributes) {
        const ytRecord = RivalIQ.utils.companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.YOUTUBE, companyAttributes);
        const hiddenYouTubeSubscriberCount = _.get(ytRecord, ['presence', 'hidden_subscriber_count']);
        return hiddenYouTubeSubscriberCount;
    }

    incompleteData.getIncompleteDataPopover = function (primaryDimension, dimensionValue, metric, calculationMetadata) {

        if (primaryDimension === 'companySetId') {
            const aggregateName = metric.get('companyIdAggregate').replace('companies', '').toLowerCase();
            const incompleteDataDetails = RivalIQ.utils.incompleteData.getBenchmarkIncompleteDataDetails(calculationMetadata, metric, {
                name: RivalIQ.state.utils.getCompanySetName(dimensionValue),
                aggregateName: aggregateName
            });

            if (incompleteDataDetails && incompleteDataDetails.partialDataTooltip) {
                return {
                    popover: incompleteDataDetails.partialDataTooltip
                };
            }
        } else if (metric.get('benchmarkCompaniesFilter')) {
            const benchmarkCompareAgainst = RivalIQ.apps.Overview.utils.getSelectedBenchmarkCompareAgainst(metric.get('selectedBenchmarkCompareAgainst'));
            const incompleteDataDetails = RivalIQ.utils.incompleteData.getBenchmarkIncompleteDataDetails(calculationMetadata, metric, benchmarkCompareAgainst);

            if (incompleteDataDetails && incompleteDataDetails.partialDataTooltip) {
                return {
                    popover: incompleteDataDetails.partialDataTooltip
                };
            }
        } else if (calculationMetadata) {
            const company = RivalIQ.state.landscape.getCompanyById(dimensionValue);
            if (calculationMetadata.missingAllSources) {
                // Single Company no history: Lacking ANY historical data b/c new company

                const earliestDataDate = moment.utc(calculationMetadata.firstPresenceData).format('MMMM D, YYYY');
                const content = `
                    <strong>This company was added to Rival IQ after the selected time period. We do not have audience history before ${earliestDataDate}.</strong>
                    <p>Change the dates and learn more about data limits in our <a href="https://help.rivaliq.com/en/articles/4792456-why-can-t-i-see-historical-audience-data" target="_blank">help center</a>.</p>
                    `;

                return {
                    popover: {
                        title: null,
                        content: content
                    }
                };
            } else if (!_.isEmpty(calculationMetadata.missingSources)) {
                // Single Company missing channel(s): Lacking historical data for 1 or more channel

                if (_.isEqual([RivalIQ.enums.sources.YOUTUBE], calculationMetadata.missingSources)) {
                    if (isYouTubeSubCountHidden(company.attributes)) {
                        return {
                            popover: {
                                title: null,
                                content: 'This audience total doesn’t include YouTube because the account owner has hidden the subscriber count in YouTube.'
                            }
                        };
                    }
                }

                const sourceList = $.tagHtml('ul', {
                    html: _.map(calculationMetadata.missingSources, missingSource => {

                        if (missingSource === RivalIQ.enums.sources.YOUTUBE && isYouTubeSubCountHidden(company.attributes)) {
                            return $.tagHtml('li', {
                                text: 'YouTube hidden by account owner.'
                            });
                        }

                        const earliestDate = getLatestDate(missingSource, company.attributes, 'earliestPresenceData');
                        const dateStr = moment.utc(earliestDate.date).format('MMMM D, YYYY');

                        return $.tagHtml('li', {
                            text: `${earliestDate.channel} available after ${dateStr}.`
                        });
                    }).join(' ')
                });

                let preamble;
                switch (metric.get('timeAnalysisMode')) {
                    case RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE:
                        preamble = 'We cannot calculate the absolute change because the previous period is missing channel data.';
                        break;

                    case RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE:
                        preamble = 'We cannot calculate the percent change because the previous period is missing channel data.';
                        break;

                    case RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD:
                    case RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD:
                    default:
                        preamble = 'This audience total is missing current channels.';
                }

                const content = `
                    <strong>${preamble}</strong>
                    <p class="no-data-description">
                    ${sourceList}
                    </p>
                    Change the dates, <a href="/companies" target="_blank">turn off the channels</a>, or <a href="https://help.rivaliq.com/en/articles/4792456-why-can-t-i-see-historical-audience-data" target="_blank">learn more</a>.
                    `;

                return {
                    popover: {
                        title: null,
                        content: content
                    }
                };
            }
        }
    };

    function getCrossChannelAudienceTooltip(calculationMetadata, metric, benchmarkCompareAgainstOption) {

        let companiesMissingDataMessage = '';
        const timeAnalysisMode = metric.get('timeAnalysisMode');
        const benchmarkName = benchmarkCompareAgainstOption.name.toLowerCase();

        let canComputeMetric;
        let isDeltaMetric = false;
        let numMissingCompanies;
        let numCompaniesWithPartialData;
        let showTurnOffChannelSuggestion = false;

        switch (timeAnalysisMode) {
            case RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD:
                canComputeMetric = calculationMetadata.period1HasEnoughPresenceData;
                numMissingCompanies = calculationMetadata.period2NumCompanies - _.size(calculationMetadata.period1NumCompaniesWithPresenceData);
                numCompaniesWithPartialData = _.size(calculationMetadata.period1CompaniesMissingChannelData);
                break;

            case RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE:
            case RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE:
                isDeltaMetric = true;
                canComputeMetric = calculationMetadata.period1HasEnoughPresenceData &&
                    calculationMetadata.period2HasEnoughPresenceData &&
                    _.isEqual(calculationMetadata.period1NumCompaniesWithPresenceData, calculationMetadata.period2NumCompaniesWithPresenceData);
                numMissingCompanies = calculationMetadata.period2NumCompanies - _.size(calculationMetadata.period2NumCompaniesWithPresenceData);
                numCompaniesWithPartialData = _.size(calculationMetadata.period2CompaniesMissingChannelData);
                break;

            case RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD:
            default:
                canComputeMetric = calculationMetadata.period2HasEnoughPresenceData;
                numMissingCompanies = calculationMetadata.period2NumCompanies - _.size(calculationMetadata.period2NumCompaniesWithPresenceData);
                numCompaniesWithPartialData = _.size(calculationMetadata.period2CompaniesMissingChannelData);
        }

        if (!canComputeMetric) {
            // ≤ 60% companies can be computed, no data can be computed.
            if (isDeltaMetric) {
                const changeType = (timeAnalysisMode === RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE ? 'absolute' : 'percent');
                companiesMissingDataMessage = `We cannot calculate the ${changeType} change because the previous period is missing channel data.`;
            } else {
                companiesMissingDataMessage = `A ${benchmarkName} is not available because some of the companies are missing data during this time period.`;
            }

        } else {

            if (numMissingCompanies === 0) {
                if (numCompaniesWithPartialData > 0) {
                    // All companies included but some companies are missing channel(s)
                    companiesMissingDataMessage = 'Some companies are missing one or more channels.';
                    showTurnOffChannelSuggestion = true;
                }
            } else {
                if (numCompaniesWithPartialData === 0) {
                    // some companies are new, but no channels are missing
                    companiesMissingDataMessage = 'Some companies were not included in this calculation because those companies are new to Rival IQ and we do not have audience history for them.';

                } else {
                    // some companies are not included and some comp. missing channels
                    const aggregateName = benchmarkCompareAgainstOption.aggregateName || 'competitor average';
                    companiesMissingDataMessage = `Some companies were not included in the ${aggregateName} because they are missing data.`;
                    showTurnOffChannelSuggestion = true;
                }
            }
        }

        const sourcesWithPartialData = _.keyBy(calculationMetadata.period2SourcesWithPartialData);
        let channelBullets;

        if (numCompaniesWithPartialData === 0 || !canComputeMetric) {
            // Just one bullet, show the date after which we have complete data.
            const dateStr = moment.utc(calculationMetadata.allPresenceDataAvailableDate).format('MMMM D, YYYY');
            channelBullets = `
                <ul>
                <li>A complete ${benchmarkName} is available after ${dateStr}.</li>
                </ul>`;
        } else {
            // For each channel, show a bullet for when we have data.
            channelBullets = $.tagHtml('ul', {
                html: _.map(calculationMetadata.allPresenceDateBySource, (dateWithAllData, source) => {
                    source = Number(source);
                    if (source === RivalIQ.enums.sources.CROSS_CHANNEL || !sourcesWithPartialData[source]) {
                        return '';
                    }

                    const dateStr = moment.utc(dateWithAllData).format('MMMM D, YYYY');

                    return $.tagHtml('li', {
                        text: `All ${RivalIQ.data.channels.get(source).get('name')} data available after ${dateStr}.`
                    });
                }).join(' ')
            });
        }

        const suggestedAction = (showTurnOffChannelSuggestion ?
            'Change the dates, <a href="/companies" target="_blank">turn off the channels</a>, or <a target="_blank" href="https://help.rivaliq.com/frequently-asked-questions/about-data/what-does-not-enough-history-mean">learn more</a>.' :
            'Change the dates and learn more about data limits in our <a target="_blank" href="https://help.rivaliq.com/frequently-asked-questions/about-data/what-does-not-enough-history-mean">help center</a>.');

        const description = `
            <strong>${companiesMissingDataMessage}</strong>
            <p>
              ${channelBullets}
              ${suggestedAction}
            </p>`;

        return {
            content: description
        };
    }

    const incompleteDataPopoverTemplate = incompleteData.incompleteDataPopoverTemplate = _.template('<p class="no-data-title-bold"><%= title %></p><p class="no-data-description"><%= description %></p>');
    incompleteData.incompleteDataPopoverTemplateNoBold = _.template('<p class="no-data-title"><%= title %></p><p class="no-data-description"><%= description %></p>');
    const incompleteDataPopoverTemplateNoTitle = _.template('<p class="no-data-description"><%= description %></p>');

    incompleteData.getBenchmarkIncompleteDataDetails = function (calculationMetadata, metric, benchmarkCompareAgainstOption, metricDimensions) {

        const noHistoricData = metric.getNoHistoricData();
        const source = metric.get('source');
        const timeAnalysisMode = metric.get('timeAnalysisMode');

        const results = {};

        if (!calculationMetadata) {
            return;
        }

        const hasEnoughDataKey = RivalIQ.metric.property.hasEnoughDataKey(metric.attributes);
        const mainPeriodDataAvailable = calculationMetadata[`period2HasEnough${hasEnoughDataKey}`];
        const comparePeriodDataAvailable = calculationMetadata[`period1HasEnough${hasEnoughDataKey}`];

        results.earliestDataDate = calculationMetadata[`earliest${hasEnoughDataKey}Since`];
        results.allDataAvailableDate = calculationMetadata[`all${hasEnoughDataKey}AvailableDate`];
        results.companiesWithData = calculationMetadata[`period2NumCompaniesWith${hasEnoughDataKey}`];
        const compareCompaniesWithData = calculationMetadata[`period1NumCompaniesWith${hasEnoughDataKey}`];
        results.numMissingCompanies = calculationMetadata.period2NumCompanies - _.size(results.companiesWithData);

        switch (timeAnalysisMode) {
            case RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD:
                results.dataNotAvailable = !comparePeriodDataAvailable;
                break;

            case RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE:
            case RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE:
                results.dataNotAvailable = !mainPeriodDataAvailable || !comparePeriodDataAvailable ||
                    !_.isEqual(results.companiesWithData, compareCompaniesWithData);
                break;

            case RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD:
            default:
                results.dataNotAvailable = !mainPeriodDataAvailable;
        }

        let companiesWord = (results.numMissingCompanies === 1 ? 'company' : 'companies');
        const benchmarkName = benchmarkCompareAgainstOption.name.toLowerCase();
        const description = (noHistoricData ? getNoHistoricalDataDescription() : getNoHistoricalDataDescription());
        const metricTypeName = (noHistoricData ? 'audience' : RivalIQ.data.channels.get(source).get('postName'));

        const intervals = _.values(RivalIQ.enums.timePeriod.interval);
        const interval = _.find(metricDimensions, function (dimension) {
            return _.includes(intervals, dimension);
        });

        if (noHistoricData && source === RivalIQ.enums.sources.CROSS_CHANNEL) {
            // Cross-channel audience metrics have their own special set of rules.
            const numMainSourcesNotIncluded = _.size(calculationMetadata.period2SourcesMissingPresenceData);
            const numCompareSourcesNotIncluded = _.size(calculationMetadata.period1SourcesMissingPresenceData);
            const numCompaniesWithPartialData = _.size(calculationMetadata.period2CompaniesMissingChannelData);

            if (numCompaniesWithPartialData > 0 && numMainSourcesNotIncluded > 0) {
                // missing companies and channel data
                results.hasPartialData = true;
                results.partialDataMessage = 'Data Incomplete';
            } else if (numMainSourcesNotIncluded > 0) {
                // only missing channel data in current period
                results.hasPartialData = true;
                results.partialDataMessage = 'Channel Data Incomplete';
            } else if (numCompareSourcesNotIncluded > 0) {
                // No warning if current period is fine but previous is missing data.
                results.hasPartialData = true;
            } else if (numCompaniesWithPartialData > 0) {
                companiesWord = (numCompaniesWithPartialData === 1 ? 'company is' : 'companies are');
                results.hasPartialData = true;
                results.partialDataMessage = `${numCompaniesWithPartialData} ${companiesWord} missing some channel data.`;
            }

            if (results.dataNotAvailable) {
                results.dataNotAvailableTooltip = getCrossChannelAudienceTooltip(calculationMetadata, metric, benchmarkCompareAgainstOption);
                return results;
            }
            if (results.hasPartialData) {
                results.partialDataTooltip = getCrossChannelAudienceTooltip(calculationMetadata, metric, benchmarkCompareAgainstOption);
                return results;
            }
        }

        if (interval) {
            const numMissingDataPoints = calculationMetadata[`${interval + hasEnoughDataKey}NumMissingDataPoints`];
            const numMissingCompanies = calculationMetadata[`${interval + hasEnoughDataKey}NumMissingCompanies`];

            if (numMissingDataPoints) {
                // Line chart: average line shows but mix of 1+ companies and 1+ dots are missing
                let missingDataPointsDescription;
                if (numMissingDataPoints === 1) {
                    missingDataPointsDescription = '1 company is';
                } else {
                    missingDataPointsDescription = 'Some companies are';
                }
                missingDataPointsDescription += ' not included in some data points.';

                results.dataNotAvailableTooltip = {
                    content: incompleteDataPopoverTemplateNoTitle({
                        description: missingDataPointsDescription
                    })
                };
            } else if (numMissingCompanies) {
                // Line chart: average line shows but 1 or more companies are not a part of it

                let missingCompaniesDescription;
                if (numMissingCompanies === 1) {
                    missingCompaniesDescription = '1 company was';
                } else {
                    missingCompaniesDescription = `${numMissingCompanies} companies were`;
                }
                missingCompaniesDescription += ` not included in the ${benchmarkName}. Enough data for a complete ${benchmarkName} is only available starting on ${moment.utc(results.earliestDataDate).format('MMMM D, YYYY')}.`;

                results.dataNotAvailableTooltip = {
                    content: incompleteDataPopoverTemplateNoTitle({
                        description: missingCompaniesDescription
                    })
                };
            }
        } else if (calculationMetadata.period2NumCompanies === 0) {
            results.dataNotAvailableMessage = RivalIQ.state.utils.isOnlyCompanySet(RivalIQ.state.view.get('companySetDescriptor')) ? 'No competitors selected' : 'Not available';
            results.dataNotAvailableTooltip = {
                content: incompleteDataPopoverTemplateNoTitle({
                    description: `${_.upperFirst(metricTypeName)} data is not available when there are no companies in the ${benchmarkName}.`
                })
            };
        } else if (results.dataNotAvailable) {
            const channelName = RivalIQ.enums.sourceDetails[source].name;
            const missingAllCompanies = (results.numMissingCompanies === calculationMetadata.period2NumCompanies);

            let title;
            if (missingAllCompanies) {
                title = `${channelName} ${metricTypeName} data for the ${benchmarkName} is only available starting on ${moment.utc(results.earliestDataDate).format('MMMM D, YYYY')
                }. ${_.upperFirst(metricTypeName)} data is not available for any company in the ${benchmarkName} during the selected time period. `;
            } else {
                title = `${channelName} ${metricTypeName} data for the ${benchmarkName} is only available starting on ${moment.utc(results.earliestDataDate).format('MMMM D, YYYY')
                }. ${_.upperFirst(benchmarkName)} could not be calculated because Rival IQ does not have enough data for ${results.numMissingCompanies
                } ${companiesWord} to make an accurate calculation. `;
            }

            results.dataNotAvailableMessage = getDataNotAvailableMessage(results.earliestDataDate);
            results.dataNotAvailableTooltip = {
                content: incompleteDataPopoverTemplate({
                    title: title,
                    description: description
                })
            };
        } else if (results.numMissingCompanies > 0) {
            results.partialDataMessage = `${results.numMissingCompanies} ${companiesWord} not included in calculation`;

            results.partialDataTooltip = {
                content: incompleteDataPopoverTemplate({
                    title: `${results.numMissingCompanies} ${companiesWord}${results.numMissingCompanies === 1 ? ' was ' : ' were '
                    }not included in this calculation. Enough data for a complete ${benchmarkName} is only available starting on ${moment.utc(results.allDataAvailableDate).format('MMMM D, YYYY')}.`,
                    description: description
                })
            };
        }

        return results;
    };
})(RivalIQ.utils.incompleteData);
